import React from 'react';
import PageHeader from "../components/page-header/PageHeader";
import { useLocation } from 'react-router-dom';
import CategoryGrid from '../components/category-grid/CategoryGrid';

const Catalog = () => {
    const location = useLocation();
    var heading = "";
    if (location.pathname.includes('categories')) heading = 'Categories';
    if (location.pathname.includes('areas')) heading =  'Areas';
    if (location.pathname.includes('alphabets')) heading =  'alphabets';
    return (
        <>
            <PageHeader>
                {heading==='Categories' && 'Available Categories List'}
                {heading==='Areas' && 'Available Areas List'}
                {heading==='alphabets' && 'All foods by Letters'}
            </PageHeader>

            <div className="container">
                <div className="section mb-3">
                    {
                        heading === 'alphabets' ? (
                            <CategoryGrid category='alphabets' />
                            ) : (
                            <CategoryGrid category={heading.toLowerCase().charAt(0)} />
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default Catalog